// 判断是否为手机端
const isMobile = () => {
  const ua = navigator.userAgent.toLowerCase()
  return /iphone|ipad|ipod|android|blackberry|windows phone/.test(ua)
}
export default isMobile
